import { render, staticRenderFns } from "./PlanEdit.vue?vue&type=template&id=db65b878&lang=pug"
import script from "./PlanEdit.vue?vue&type=script&lang=ts"
export * from "./PlanEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports